<template>
<div class="contacts-text-block">

    <scroll-speed :speed="0.85">
        <address slot-scope="{}" class="text-container">
            <h2>{{ content.legalName }}</h2>
            <p class="phone">{{ content.phone }}</p>
            <p class="mail">{{ content.mail }}</p>
            <br>
            <p>{{ content.street }}</p>
            <p>{{ content.zip }}</p>
            <br>
            <p>{{ content.cvr }}</p>
            <p>{{ content.bank }}</p>
        </address>
    </scroll-speed>

    <div class="image-container">
        <img :src='content.image.url'
            :alt='content.image.alt'>
    </div>

    <!-- <div class="text-container">
            <section v-for="paragraph in text.paragraph1" :key="paragraph.title">
                <h2>{{paragraph.title}}</h2>
                <span v-html="paragraph.richRext"></span>
            </section>
        </div>

        <div class="text-container">
            <section v-for="paragraph in text.paragraph2" :key="paragraph.title">
                <h2>{{paragraph.title}}</h2>
                <span v-html="paragraph.richRext"></span>
            </section>
        </div> -->

</div>
</template>

<script>
import { mapState } from 'vuex'
import ScrollSpeed from "@/components/scroll-speed";

export default {
    name: "ContactsViewTextBlock",
    components: {
        ScrollSpeed
    },
    computed: mapState({
        content(state) {
            return state.data.contactsPage
        }
    }),
}
</script>

<style lang="scss">
@import "../scss/globals.scss";

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.contacts-text-block {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    font-family: $font-regular;
    font-size: $font-size-xs;
    line-height: $medium-line-height;

    padding: $margin2-1 0 $margin2-1 $margin1-8;

    @media screen and (min-width: 377px) {
        font-size: $font-size-s;
        line-height: 2;
    }

	@media screen and (min-width: 440px) {
		padding-left: $margin1-4;
	}
	@media screen and (min-width: 769px) {
		padding-left: $margin1-2;
	}
	@media screen and (min-width: 1440px) {
		padding-left: $margin1-1;
	}

    .text-container {
        width: 100%;

        box-sizing: border-box;
        z-index: 1;

        font-style: normal;

        @media screen and (min-width: 768px) {
            width: 35%;
        }

        h2 {
            font-size: $font-size-sm;
            font-family: $font-expanded;

            @media screen and (min-width: 1060px) {
                font-size: $font-size-m;
            }
        }

        .mail,
        .phone {
            font-size: $font-size-sm;
            font-family: $font-expanded;
            line-height: 1.2;

            white-space: nowrap;

            @media screen and (min-width: 1060px) {
                font-size: $font-size-m;
            }
        }
    }

    .image-container {
        margin-top: $margin2-1;

        @media screen and (min-width: 377px) {
            margin-top: $margin1-1;
        }

        @media screen and (min-width: 768px) {
            width: 65%;
            margin-top: 0;
            margin-left: auto;
        }

        img {
            animation: fadeIn 3s forwards ease;
            width: 100%;
        }
    }
}
</style>
